import React, { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import axios from "axios";
import "./AddTreatmentPlanModal.css";

const AddTreatmentPlanModal = ({ show, onClose, risk, onCreated, showToast }) => {
  const [form, setForm] = useState({
    risk_id: null,
    title: "",
    owner: "",
    action: "Reduce",
    status: "Planned",
    justification: "",
    planned_date: "",
    completion_date: "",
    progress: 0,
    ressources: [],
    mesures: [],
  });

  useEffect(() => {
    if (show && risk?.id) {
      setForm((prev) => ({
        ...prev,
        risk_id: risk.id,
        ressources: [],
        mesures: [],
      }));
    }
  }, [show, risk]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === "progress" ? parseInt(value) || 0 : value,
    }));
  };

  const handleMultiSelect = (e) => {
    const { name, selectedOptions } = e.target;
    const values = Array.from(selectedOptions).map((opt) => opt.value);
    setForm((prev) => ({
      ...prev,
      [name]: values,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("/api/add_treatment_plan.php", form);
      showToast("Treatment plan added!");
      onCreated?.();
      onClose();
    } catch (err) {
      console.error("Add treatment error:", err);
      showToast("Server error", "danger");
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered dialogClassName="add-treatment-modal">
      <Form onSubmit={handleSubmit}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="bi bi-clipboard-check me-2 text-success" />
              Add Treatment Plan
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} />
          </div>

          <div className="modal-body">
            {/* 📝 Title & Owner */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  name="title"
                  value={form.title}
                  onChange={handleChange}
                  placeholder="e.g. Deploy Firewall"
                />
              </div>
              <div className="col-md-6 mb-3">
                <Form.Label>Owner</Form.Label>
                <Form.Control
                  name="owner"
                  value={form.owner}
                  onChange={handleChange}
                  placeholder="e.g. John Doe"
                />
              </div>
            </div>

            {/* 🎯 Action & Status */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <Form.Label>Action</Form.Label>
                <Form.Select name="action" value={form.action} onChange={handleChange}>
                  <option value="Avoid">Avoid</option>
                  <option value="Reduce">Reduce</option>
                  <option value="Transfer">Transfer</option>
                  <option value="Accept">Accept</option>
                </Form.Select>
              </div>
              <div className="col-md-6 mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select name="status" value={form.status} onChange={handleChange}>
                  <option value="Planned">Planned</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Completed">Completed</option>
                </Form.Select>
              </div>
            </div>

            {/* 📅 Dates */}
            <div className="row">
              <div className="col-md-6 mb-3">
                <Form.Label>Planned Date</Form.Label>
                <Form.Control
                  type="date"
                  name="planned_date"
                  value={form.planned_date}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6 mb-3">
                <Form.Label>Completion Date</Form.Label>
                <Form.Control
                  type="date"
                  name="completion_date"
                  value={form.completion_date}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* 📌 Ressources */}
            {risk && (
              <Form.Group className="mb-3">
                <Form.Label>Linked Resources</Form.Label>
                <Form.Select
                  name="ressources"
                  multiple
                  value={form.ressources}
                  onChange={handleMultiSelect}
                >
                  {(risk.ressources || []).map((r, i) => (
                    <option key={i} value={r}>{r}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            )}

            {/* 🧪 Measures */}
            {risk && (
              <Form.Group className="mb-3">
                <Form.Label>Mitigation Measures</Form.Label>
                <Form.Select
                  name="mesures"
                  multiple
                  value={form.mesures}
                  onChange={handleMultiSelect}
                >
                  {(risk.mesures || []).map((m, i) => (
                    <option key={i} value={m}>{m}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            )}

            {/* 🧠 Justification */}
            <Form.Group className="mb-3">
              <Form.Label>Justification</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="justification"
                value={form.justification}
                onChange={handleChange}
                placeholder="Why this action?"
              />
            </Form.Group>

            {/* 📈 Progress */}
            <Form.Group className="mb-3">
              <Form.Label>Progress</Form.Label>
              <Form.Range
                name="progress"
                value={form.progress}
                onChange={handleChange}
                min={0}
                max={100}
              />
              <div className="d-flex justify-content-end">
                <span className="progress-pill">{form.progress}%</span>
              </div>
            </Form.Group>
          </div>

          <div className="modal-footer">
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="success" type="submit">
              Add
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default AddTreatmentPlanModal;
